import { useEffect } from "react";
import useAuthentication from "./useAuthentication";
import { useQueryClient } from "@tanstack/react-query";
import connectToUserChannel from "@/websocket/connectToChannel";

type SocketSubscription = {
  unsubscribe: () => void;
};

const subscriptions: SocketSubscription[] = [];

function doUnsubscribe(subscriptions: SocketSubscription[]) {
  while (subscriptions.length) {
    const subscription = subscriptions.pop();
    if (subscription) {
      subscription.unsubscribe();
    }
  }
}

const useCurrentUserWebsocket = () => {
  const { user } = useAuthentication();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (user?.id) {
      subscriptions.push(connectToUserChannel(user.id, user.authentication_token, queryClient));
    } else {
      doUnsubscribe(subscriptions);
    }

    return () => {
      doUnsubscribe(subscriptions);
    };
  }, [user?.id]);
};

export default useCurrentUserWebsocket;
